import { Image } from '@shared/types/Image';
import { ISBAsset } from '@shared/types/storyblok';

export const storyblokAssetToImage = (asset?: ISBAsset): Image | null => {
  if (!asset?.filename) {
    return null;
  }
  return { src: asset.filename, alt: asset.alt };
};
